var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',[_c('h1',[_vm._v("Upload image")]),_c('input',{ref:"file",attrs:{"type":"file","id":"file"},on:{"change":_vm.onFileSelected}})])
}
var staticRenderFns = []

export { render, staticRenderFns }